// Runtime config para partnerPortal.
// Produccion: inyectado via /config.js desde env vars del contenedor.
// Dev local: fallback estatico.
const fallback = {
  apiUrl: 'https://api-s.coredeskpro.com',
  portalUrl: 'https://s.coredeskpro.com',
  kycSupportEmail: 'partners@coredeskpro.com',
  environment: 'development'
};

const runtime = typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined;

const pick = (key) => {
  if (!runtime) return fallback[key];
  const v = runtime[key];
  if (typeof v !== 'string' || v.startsWith('__')) return fallback[key];
  return v;
};

export const config = {
  apiUrl: pick('apiUrl'),
  portalUrl: pick('portalUrl'),
  kycSupportEmail: pick('kycSupportEmail'),
  environment: pick('environment')
};

export default config;
